import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";
import "./PurchasePrint.css";

const StockReportPrint = () => {
    const [stockData, setStockData] = useState(null);
    const { filter } = useParams();

    const dummyStockData = {
        date: new Date().toISOString().split('T')[0],
        summary: {
            total_products: 8,
            total_stock_value: 89225.00,
            low_stock_items: 3,
            out_of_stock_items: 0,
            overstock_items: 1,
            total_quantity: 378
        },
        items: [
            {
                id: 1,
                productCode: "PB004",
                productName: "Pin Box - (00:4)",
                category: "Packaging",
                currentStock: 73,
                minStock: 50,
                maxStock: 200,
                unit: "pcs",
                purchaseRate: 180.00,
                sellingRate: 200.00,
                stockValue: 13140.00,
                status: "In Stock",
                lastPurchaseDate: "2025-11-21",
                supplier: "SSS Enterprises"
            },
            {
                id: 2,
                productCode: "GT003R",
                productName: "3 Inches Gum Tape - Red",
                category: "Tape",
                currentStock: 25,
                minStock: 30,
                maxStock: 100,
                unit: "rolls",
                purchaseRate: 75.00,
                sellingRate: 85.00,
                stockValue: 1875.00,
                status: "Low Stock",
                lastPurchaseDate: "2025-11-20",
                supplier: "ABC Suppliers"
            },
            {
                id: 3,
                productCode: "GT003O",
                productName: "3 Inches Gum Tape - Orange",
                category: "Tape",
                currentStock: 45,
                minStock: 30,
                maxStock: 100,
                unit: "rolls",
                purchaseRate: 70.00,
                sellingRate: 80.00,
                stockValue: 3150.00,
                status: "In Stock",
                lastPurchaseDate: "2025-11-19",
                supplier: "XYZ Traders"
            },
            {
                id: 4,
                productCode: "GT003Y",
                productName: "3 Inches Gum Tape - Yellow",
                category: "Tape",
                currentStock: 15,
                minStock: 30,
                maxStock: 100,
                unit: "rolls",
                purchaseRate: 65.00,
                sellingRate: 75.00,
                stockValue: 975.00,
                status: "Low Stock",
                lastPurchaseDate: "2025-11-18",
                supplier: "Global Imports"
            },
            {
                id: 5,
                productCode: "PB005",
                productName: "Pin Box - (00:5)",
                category: "Packaging",
                currentStock: 120,
                minStock: 50,
                maxStock: 200,
                unit: "pcs",
                purchaseRate: 190.00,
                sellingRate: 210.00,
                stockValue: 22800.00,
                status: "In Stock",
                lastPurchaseDate: "2025-11-17",
                supplier: "SSS Enterprises"
            },
            {
                id: 6,
                productCode: "GT004R",
                productName: "4 Inches Gum Tape - Red",
                category: "Tape",
                currentStock: 60,
                minStock: 20,
                maxStock: 80,
                unit: "rolls",
                purchaseRate: 95.00,
                sellingRate: 110.00,
                stockValue: 5700.00,
                status: "Overstock",
                lastPurchaseDate: "2025-11-16",
                supplier: "ABC Suppliers"
            },
            {
                id: 7,
                productCode: "GT004O",
                productName: "4 Inches Gum Tape - Orange",
                category: "Tape",
                currentStock: 5,
                minStock: 20,
                maxStock: 80,
                unit: "rolls",
                purchaseRate: 90.00,
                sellingRate: 105.00,
                stockValue: 450.00,
                status: "Low Stock",
                lastPurchaseDate: "2025-11-15",
                supplier: "XYZ Traders"
            },
            {
                id: 8,
                productCode: "WR001",
                productName: "Wooden Box - Small",
                category: "Packaging",
                currentStock: 35,
                minStock: 25,
                maxStock: 100,
                unit: "pcs",
                purchaseRate: 350.00,
                sellingRate: 400.00,
                stockValue: 12250.00,
                status: "In Stock",
                lastPurchaseDate: "2025-11-14",
                supplier: "Global Imports"
            }
        ]
    };

    useEffect(() => {
        setStockData(dummyStockData);
        setTimeout(() => window.print(), 800);
    }, [filter]);

    if (!stockData) return null;

    const getStatusColor = (status) => {
        switch(status) {
            case 'In Stock': return '#28a745';
            case 'Low Stock': return '#ffc107';
            case 'Out of Stock': return '#dc3545';
            case 'Overstock': return '#17a2b8';
            default: return '#6c757d';
        }
    };

    return (
        <div className="print-page">
            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">
                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: 33ABCDE1234F1Z5</div>
                    <div className="title">STOCK REPORT</div>
                </div>

                {/* COMPANY BLOCK */}
                <div className="company-section">
                    <img src={Logo} width="70" alt="logo" />

                    <div className="company-details">
                        <h2>SDS POLYTECHNIC</h2>
                        <div>College Road, Campus Area</div>
                        <div>Coimbatore, Tamil Nadu - 641012</div>
                        <div>Mobile: 0422-1234567</div>
                    </div>
                </div>

                {/* REPORT INFO */}
                <div className="bill-info">
                    <div><b>Report Date:</b> {new Date(stockData.date).toLocaleDateString('en-IN')}</div>
                    <div><b>Generated On:</b> {new Date().toLocaleDateString('en-IN')}</div>
                    <div><b>Total Products:</b> {stockData.summary.total_products}</div>
                </div>

                {/* SUMMARY SECTION */}
                <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #000', fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div><b>Total Stock Value:</b> ₹{stockData.summary.total_stock_value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Low Stock Items:</b> {stockData.summary.low_stock_items}</div>
                        <div><b>Out of Stock:</b> {stockData.summary.out_of_stock_items}</div>
                        <div><b>Overstock Items:</b> {stockData.summary.overstock_items}</div>
                        <div><b>Total Quantity:</b> {stockData.summary.total_quantity}</div>
                    </div>
                </div>

                {/* STOCK ITEMS TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Product Code</th>
                            <th>Product Name</th>
                            <th>Category</th>
                            <th>Current Stock</th>
                            <th>Min Stock</th>
                            <th>Max Stock</th>
                            <th>Unit</th>
                            <th>Purchase Rate</th>
                            <th>Stock Value</th>
                            <th>Status</th>
                            <th>Supplier</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stockData.items.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td><strong>{item.productCode}</strong></td>
                                <td>{item.productName}</td>
                                <td>{item.category}</td>
                                <td style={{ 
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    color: getStatusColor(item.status)
                                }}>
                                    {item.currentStock}
                                </td>
                                <td style={{ textAlign: 'center' }}>{item.minStock}</td>
                                <td style={{ textAlign: 'center' }}>{item.maxStock}</td>
                                <td style={{ textAlign: 'center' }}>{item.unit}</td>
                                <td style={{ textAlign: 'right' }}>₹{item.purchaseRate.toFixed(2)}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>₹{item.stockValue.toFixed(2)}</td>
                                <td>
                                    <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: getStatusColor(item.status),
                                        color: 'white'
                                    }}>
                                        {item.status}
                                    </span>
                                </td>
                                <td>{item.supplier}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* STOCK STATUS SUMMARY */}
                <div style={{ marginTop: '20px', fontSize: '13px' }}>
                    <b>Stock Status Summary:</b>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: '8px', gap: '10px' }}>
                        <div>
                            <span style={{ color: '#28a745', fontWeight: 'bold' }}>● In Stock:</span> {stockData.items.filter(item => item.status === 'In Stock').length} items
                        </div>
                        <div>
                            <span style={{ color: '#ffc107', fontWeight: 'bold' }}>● Low Stock:</span> {stockData.items.filter(item => item.status === 'Low Stock').length} items
                        </div>
                        <div>
                            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>● Out of Stock:</span> {stockData.items.filter(item => item.status === 'Out of Stock').length} items
                        </div>
                        <div>
                            <span style={{ color: '#17a2b8', fontWeight: 'bold' }}>● Overstock:</span> {stockData.items.filter(item => item.status === 'Overstock').length} items
                        </div>
                    </div>
                </div>

                {/* VALUE SUMMARY */}
                <div style={{ marginTop: '15px', padding: '8px', borderTop: '1px solid #000', fontSize: '13px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>Total Inventory Value:</div>
                        <div>₹{stockData.summary.total_stock_value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                    </div>
                </div>

                {/* SIGNATURE */}
                <div className="signature-section">
                    <b>For SDS POLYTECHNIC</b>
                    <br /><br /><br />
                    <b>Authorized Signature</b>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Stock Report
                </div>
            </div>
        </div>
    );
};

export default StockReportPrint;